<template>
    <div v-if="!consent" class="z-50 bg-white text-gray-900 fixed bottom-2 left-2 px-5 py-8 rounded shadow-lg border border-gray-200 mr-2 w-1/3 lg:w-1/2 md:w-2/3 sm:w-auto">
        <b>Cookie toestemming</b>
        <div v-if="showSettings" class="text-xs">

            <label for="functionele_cookies" class="flex items-center cursor-pointer mb-3">
                <div class="relative">
                    <input id="functionele_cookies" type="checkbox" class="sr-only" disabled v-model="functional"/>
                    <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                    <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
                </div>
                <div class="ml-3 text-gray-700"><span class="font-medium">Functionele cookies:</span> Deze cookies zijn altijd nodig voor een goed functioneren van de website en kunnen niet uitgeschakeld worden.</div>
            </label>


            <label for="analytics_cookies" class="flex items-center cursor-pointer mb-3">
                <div class="relative">
                    <input id="analytics_cookies" type="checkbox" class="sr-only" v-model="analytics" />
                    <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                    <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
                </div>
                <div class="ml-3 text-gray-700"><span class="font-medium">Analytische cookies:</span> Deze cookies worden gebruikt om statistieken en informatie over het gebruik van onze website bij te houden.</div>
            </label>

            <label for="marketing_cookies" class="flex items-center cursor-pointer mb-3">
                <div class="relative">
                    <input id="marketing_cookies" type="checkbox" class="sr-only" v-model="marketing" />
                    <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                    <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
                </div>
                <div class="ml-3 text-gray-700"><span class="font-medium">Marketing cookies:</span> Deze cookies worden gebruikt ter optimalisatie van onze advertenties op verschillende platformen.</div>
            </label>

            <div class="float-right flex">
                <div @click="hideSettings" class="underline font-semibold mr-4 py-2 text-sm cursor-pointer">Annuleren</div>
                <div @click="cookieConsent.giveConsent" class="text-sm border border-gray-400 rounded px-4 py-2 bg-green-600 hover:bg-green-500 cursor-pointer text-white">Opslaan en doorgaan</div>
            </div>
        </div>
        <div v-else>
            <p class="text-sm">Wij, en derde partijen, maken op onze website gebruik van cookies. Wij gebruiken cookies voor het bijhouden van statistieken, om online in te schrijven, maar ook voor marketingdoeleinden (bijvoorbeeld het afstemmen van advertenties). Door op ‘Zelf instellen’ te klikken, kun je meer lezen over onze cookies en je voorkeuren aanpassen. Door op ‘Accepteren en doorgaan’ te klikken, ga je akkoord met het gebruik van alle cookies <NuxtLink to="/cookies" class="underline">zoals omschreven in onze cookieverklaring.</NuxtLink></p>
            <div class="float-right flex">
                <div @click="settings" class="underline font-semibold mr-4 py-2 text-sm cursor-pointer">Zelf instellen</div>
                <div @click="giveAllConsent" class="text-sm border border-gray-400 rounded px-4 py-2 bg-green-600 hover:bg-green-500 cursor-pointer text-white">Accepteren en doorgaan</div>
            </div>
        </div>
  </div>
</template>

<script setup>
    const cookieConsent = useCookieConsentStore();
    const { consent, cookies } = storeToRefs(cookieConsent);
    const showSettings = ref(false);

    const functional = computed({
        get() {
            return cookies.value.functional
        },
        set(functional) {
            // verplicht enabled!
            functional = true;
            cookieConsent.setCookies({functional})
        }
    });

    const marketing = computed({
        get() {
            return cookies.marketing
        },
        set(marketing) {
            cookieConsent.setCookies({marketing})
        }
    });

    const analytics = computed({
        get() {
            return cookies.analytics
        },
        set(analytics) {
            cookieConsent.setCookies({analytics})
        }
    });

    const settings = () => showSettings.value = true;
    const hideSettings = () => showSettings.value = false;
    const giveAllConsent = () => {
        functional.value = true;
        marketing.value = true;
        analytics.value = true;
        cookieConsent.giveConsent();
    }






</script>

<style>
input:checked ~ .dot {
  transform: translateX(100%);
  background-color: #48bb78 !important;
}
</style>